import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Customform from "./CustomForm.js";
import AWS from "../../../utils/awsConfig.js";
import { LOADING, MODE } from "../../../constants/SiteConstants";

const API_URL = process.env.REACT_APP_API_URL;

const fields = [
  { label: "Title", name: "title", placeholder: "Enter Title", required: true },
  {
    label: "Description",
    name: "description",
    placeholder: "Enter description",
    type: "rich-text",
    required: true,
  },
  {
    label: "Is Featured",
    name: "isFeatured",
    type: "select",
    options: [
      { label: "True", value: true },
      { label: "False", value: false },
    ],
  },
  {
    label: "Image",
    name: "image",
    placeholder: "Choose Images",
    type: "file",
  },
];

const EditOffer = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [initialData, setInitialData] = useState(null);
  const [imageFiles, setImageFiles] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  useEffect(() => {
    if (id) fetchOfferData();
  }, [id]);

  const fetchOfferData = async () => {
    try {
      const { data } = await axios.get(`${API_URL}/offers/getOfferById/${id}`);
      setInitialData(data);
      setImagePreview(data.image);
    } catch (error) {
      toast.error("Failed to load offer data");
    }
  };

const handleImageUpload = async (file) => {
  if (!file) {
    toast.error("No file selected!");
    return null;
  }

  const formData = new FormData();
  formData.append("image", file);

  try {
    const response = await fetch(`${API_URL}/image/upload`, {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || "Upload failed");
    }

    return data.imageUrl;
  } catch (error) {
    console.error("Upload Error:", error);
    toast.error("Error uploading image: " + error.message);
    return null;
  }
};
  const handleSubmit = async (formData) => {
    try {
      toast.info("Updating offer...");
  
      let imageUrl = initialData.image || "";
  
      // If new image selected
      if (imageFiles) {
        const s3 = new AWS.S3();
  
        // Delete old image if exists
        if (imageUrl) {
          const oldImageKey = imageUrl.split("/").pop();
          await s3
            .deleteObject({
              Bucket: "solar-station",
              Key: oldImageKey,
            })
            .promise();
        }
  
        // Upload new image
        const uploadedImage = await handleImageUpload(imageFiles);
        imageUrl = uploadedImage;
      }
  
      const payload = {
        ...formData,
        image: imageUrl,
      };
  
      await axios.put(`${API_URL}/offers/updateOffer/${id}`, payload);
  
      toast.success("Offer updated successfully");
      navigate("/offers");
    } catch (error) {
      toast.error(error?.response?.data?.message || "Error updating offer");
    }
  };
  
  
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImagePreview(URL.createObjectURL(file)); // for preview
      setImageFiles(file); // store single file
    }
  };
  

  return (
    <div className="form-wrapper shadow-md">
      <div className="form-header">
        <h3 className="font-medium text-black border-b border-gray-300 pb-2 w-full">
          Update Offer
        </h3>
        <button className="form-close-btn" onClick={() => navigate("/offers")}>
          &times;
        </button>
      </div>

      {initialData ? (
        <Customform
          mode={MODE.UPDATE}
          onSubmit={handleSubmit}
          fields={fields}
          initialData={initialData}
          imagePreviews={imagePreview}
          handleCustomerImageChange={handleImageChange}
        />
      ) : (
        <p>{LOADING}</p>
      )}
    </div>
  );
};

export default EditOffer;
